import { Suspense, cloneElement } from 'react'
import { Loader } from '@nv/basic-components'

export const NvRoute = ({ layout: Layout = null, component: Component = null, render = null }) => {
  // prettier-ignore
  return Layout ? (
    typeof Layout === 'function' ? (
      <Layout>
        <Suspense fallback={ <div><Loader /></div>}>
          {render ? render() : <Component />}
        </Suspense>
      </Layout>
    ) : (
      cloneElement(Layout, null,
        <Suspense fallback={<div><Loader /></div>}>
          {render ? render() : <Component />}
        </Suspense>,
      )
    )
  ) : (
    <Suspense fallback={<div><Loader /></div>}>
      {render ? render() : <Component />}
    </Suspense>
  )
}
